import { Components } from '@mui/material';
import { Theme } from '@mui/system';
import { fontFamily } from './typography';

export const buildMuiFormHelperTextComponent = (): Components<Omit<Theme, 'components'>>['MuiFormHelperText'] => ({
  styleOverrides: {
    root: ({ theme }) => ({
      fontFamily,
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '14px',
      lineHeight: '150%',
      color: theme.palette.primary.main,
      margin: '8px 0 0',
    }),
    error: ({ theme }) => ({
      color: theme.palette.error.main,
    }),
    sizeSmall: {
      fontSize: '11px',
    },
  },
});

export const buildMuiFormControlComponent = (): Components<Omit<Theme, 'components'>>['MuiFormControl'] => ({
  styleOverrides: {
    root: {
      margin: '8px 0 0',
    },
  },
});
